const DEFAULT_QUIZ_SERVER_BASE_URL = 'https://dev-quiz-api.zep.us';

type AiServerRequestHeaderValues = {
  token?: string | null;
  serverName?: string | null;
  fingerprintId?: string | null;
};

export const getConfiguredAiServerBaseUrl = () => {
  return process.env['NEXT_PUBLIC_AI_SERVER_BASEURL'];
};

export function extractServerName(
  zepServerApiUrl = process.env['NEXT_PUBLIC_SERVER_BASEURL'] ??
    DEFAULT_QUIZ_SERVER_BASE_URL,
) {
  return zepServerApiUrl.split('-quiz-api')[0].split('//')[1] ?? '';
}

export const createAiServerRequestHeaders = ({
  token,
  serverName,
  fingerprintId,
}: AiServerRequestHeaderValues) => {
  const headers: Record<string, string> = {};

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (serverName) {
    headers['X-Quiz-Server-Name'] = serverName;
  }

  if (fingerprintId) {
    headers['X-Fingerprint-Id'] = fingerprintId;
  }

  return headers;
};
